import Blason from "./Blason";
import Wordmark from "./Wordmark";
import { Title, Kicker } from "./bits";
import { T, PILLARS } from "./content";

export default function Maison({ lang }) {
  const t = T[lang];
  return (
    <section className="section" id="maison" data-testid="section-maison">
      <div className="container maison__grid">
        <div className="seal reveal">
          <i className="seal__ring" />
          <div className="seal__inner">
            <Blason className="seal__crest" />
            <Wordmark className="seal__wordmark" />
            <span className="sub">LUXEMBOURG</span>
          </div>
        </div>

        <div className="maison__body">
          <div className="reveal">
            <Kicker withDash>{t.maisonKicker}</Kicker>
            <Title parts={t.maisonTitle} className="" tag="h2" />
          </div>
          <p className="lead reveal">{t.maisonP1}</p>
          <p className="lead reveal">{t.maisonP2}</p>

          <div className="pillars">
            {PILLARS.map((p) => (
              <div className="pillar reveal" key={p.num}>
                <span className="pillar__num">{p.num}</span>
                <span className="pillar__txt">{lang === "fr" ? p.fr : p.en}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
